import {
  HealthcheckItem,
  HealthcheckItemProps,
  HealthcheckList,
  Typography,
} from '@alice-financial/pretext-ui'
import * as React from 'react'
import { OrganizationDetailFragment, FormNameEnum } from '@alice-financial/alice-sdk'
import { useCurrentOrgRootPath, useOrg } from '../../organization/useOrg'
import { PageBody } from '../../../routes/PageBody'
import { QuestionPage } from '../../../survey/types'
import { PagedOrgForm } from '../PagedOrgForm'

import { existingEmployees } from './ExistingEmployeesInputs'
import { goalsInputs } from './GoalsInputs'
import { goalStory } from './GoalStory'
import { languages } from './LanguagesInputs'
import { newEmployees } from './NewEmployeesInputs'
import { useEnrollmentSuccessStatus } from './useEnrollmentSuccessStatus'

/** * FORM CONFIGURATION ***/
const FORM_NAME = FormNameEnum.EnrollmentSuccess
const FORM_VERSION = 1
const PAGES: readonly QuestionPage[] = [languages, newEmployees, existingEmployees, goalsInputs, goalStory]
/** * END FORM CONFIGURATION ***/

export const EnrollmentSuccessPage = () => {
  const org = useOrg()
  if (!org) return null
  const todo = !org.isOnboarded
  return (
    <PageBody maxWidth="md">
      <Typography variant="h1">Enrollment Success</Typography>
      <HealthcheckList>
        <EnrollmentSuccessHealthcheck org={org} todo={todo} />
      </HealthcheckList>
    </PageBody>
  )
}

const BaseHealthcheck = ({
  step,
  disableDone,
  ...props
}: Pick<HealthcheckItemProps, 'primary' | 'secondary' | 'status' | 'todo'> & {
  step?: number
  disableDone?: boolean
}) => {
  const currentOrgRootPath = useCurrentOrgRootPath()
  const baseTargetPath = `${currentOrgRootPath}/enrollment-success`
  const targetPath = step ? `${baseTargetPath}?step=${step}` : baseTargetPath
  return (
    <HealthcheckItem to={targetPath} newRequirement {...props}>
      <PagedOrgForm formName={FORM_NAME} formVersion={FORM_VERSION} pages={PAGES} disableDone={disableDone} />
    </HealthcheckItem>
  )
}

type EnrollmentSuccessHealthcheckProps = {
  org: OrganizationDetailFragment
  todo?: boolean
}
export const EnrollmentSuccessHealthcheck = ({ org, todo }: EnrollmentSuccessHealthcheckProps) => {
  const statusResult = useEnrollmentSuccessStatus(org)

  return (
    <BaseHealthcheck
      status={statusResult.status}
      primary={statusResult.primary}
      secondary={statusResult.secondary}
      todo={todo}
    />
  )
}
